import { useState } from "react";
import styled from "styled-components";
import media from "../media-queries";
import { LogoBar } from "./logo-bar";
import { Menu } from "./menu";
import { DonateBar } from "../donate-bar";
import { PopUp } from "../popup";
import { SubMenu } from "./sub-menu";

const Wrapper = styled.div`
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 30px;
  height: ${(props) => (props.menuOpen ? "100vh" : "auto")};
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 20;

  ${media.lg} {
    height: auto;
  }
`;

const DropDownMenu = styled(Menu)`
  align-items: center;
  display: ${(props) => (props.menuOpen ? `flex` : `none`)};
  font-size: 32px;
  justify-content: center;
  flex-grow: 1;
  height: 100%;
  position: absolute;
  width: 100%;

  ${media.lg} {
    display: none;
  }

  .menu__list {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .menu__list-item {
    text-align: center;
    margin-bottom: 20px;
    display: block;
  }
`;

export const Header = (props) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <Wrapper menuOpen={menuOpen}>
        <LogoBar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
        <DropDownMenu menuOpen={menuOpen} />
        {props.showDonateBar && <DonateBar />}
        <SubMenu />
        <PopUp />
      </Wrapper>
    </>
  );
};
